import AbstractCRMApi from '../../AbstractCRMApi';
import GetWithdrawalDetailsResponse from '../Responses/WithdrawalDetailsResponse';

class WithdrawalsApi extends AbstractCRMApi {
    protected endpoint: string = 'withdrawal';

    async getWithdrawalDetails(withdrawalId: number): Promise<GetWithdrawalDetailsResponse> {
        return (await this.get(`/${withdrawalId}`)).data;
    }

    async acceptById(withdrawalId: number): Promise<GetWithdrawalDetailsResponse> {
        return (await this.post(`/${withdrawalId}/accept`)).data;
    }

    async declineById(withdrawalId: number): Promise<GetWithdrawalDetailsResponse> {
        return (await this.post(`/${withdrawalId}/decline`)).data;
    }

    async isManualWithdrawEnabled(): Promise<boolean> {
        return !!(await this.get('/manual_withdraw_enabled')).data.enabled;
    }
}

export default new WithdrawalsApi();
